function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M23,9.63A10,10,0,0,1,13.37,20h0a.5.5,0,0,1,0-1,9,9,0,0,0,5.8-15.58A9,9,0,0,0,6.35,4,9.77,9.77,0,0,0,4,10.19l2.64-3a.5.5,0,0,1,.76.66l-3.48,4a.45.45,0,0,1-.19.14h0l-.13,0H3.47l-.06,0L3.3,12l-.09,0-.07-.07-.06-.05-3-4.5a.51.51,0,0,1,.14-.7.51.51,0,0,1,.7.14L3,9.85A10.59,10.59,0,0,1,5.61,3.29a9.78,9.78,0,0,1,7-3.28A10,10,0,0,1,23,9.63Z"
})));

var SvgReActivate = function SvgReActivate(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23 19.99",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReActivate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/re-activate.96111950.svg";
export { ForwardRef as ReactComponent };